const chains = [];
chains.push({ _operation: 'getAppActivities', api: '/app/activities', defaultData: [], httpVerb: 'get' });
chains.push({ _operation: 'getAppActivitiesByContextId', api: '/app/activities/context/:contextId', defaultData: [], httpVerb: 'get' });
chains.push({ _operation: 'getAppActivitiesByUserId', api: '/app/activities/by/:userId', defaultData: [], httpVerb: 'get' });
export default chains;
